import { fetchWithAuth } from "../FetchHelper";

const apiUrl = process.env.REACT_APP_API_URL;
export const GetUsuarisIdBbddNotes = async (id_user: string) => {
    try {
        const response = await fetchWithAuth(`${apiUrl}:8061/bbdd/usuaris/${id_user}/notes`);
        if (response && response.ok) {
            return await response.json();
        }
        return [];
    } catch (error) {
        console.log('Error al obtener los datos de notas BBDD:', error);
        return [];
    }
};

